import React from 'react';
import classNames from 'classnames';
import type { IProps } from './types';
import { getStepSubType } from '../../utils/helper';
import { accessibleOnClick } from '../../../../../../../shared/utils/accessible-on-click';
import { SequenceStepAction, StepType } from '../../../../../enums';

const StepTaskType: React.FC<IProps> = ({
  label,
  stepType,
  mode,
  selectedTaskType,
  onChange,
}) => {
  const getOptions = () => Object.values(getStepSubType(stepType));

  const getOptionClasses = (item): string =>
    classNames([
      'd-flex justify-content-center',
      {
        'channel-sub-types__active': selectedTaskType === item,
        'channel-sub-types__disable':
          mode !== SequenceStepAction.CreateStep && item !== selectedTaskType,
        'channel-sub-types__type-secondary':
          stepType === StepType.Call || stepType === StepType.WhatsApp,
        'channel-sub-types__type-secondary-whatsapp':
          stepType === StepType.WhatsApp,
        'channel-sub-types__type':
          stepType !== StepType.Call && stepType !== StepType.WhatsApp,
      },
    ]);

  const handleChange = (item) =>
    mode === SequenceStepAction.CreateStep && onChange(item);

  return (
    <div className="channel-sub-types">
      <span className="semibold-1 gray-txt-15">{label}</span>
      <div className="channel-sub-types__container bs-mt-12">
        {getOptions().map((item) => (
          <div
            key={item}
            className={getOptionClasses(item)}
            {...accessibleOnClick(() => handleChange(item))}
          >
            <span className="regular-2 line-height-20 popover-arrow-color-txt">
              {item}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepTaskType;
